import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.auth.isLoggedIn()) {
      return true;
    }

    // During Auth0/OAuth callback we may temporarily not have a valid token yet,
    // but we MUST NOT trigger a new login flow, otherwise the browser can get stuck
    // in a redirect loop (URL flashing).
    try {
      const qs = window.location.search || '';
      if (qs.includes('code=') || qs.includes('error=') || qs.includes('state=')) {
        return true;
      }
    } catch {}

    try {
      let target = state && state.url ? state.url : '/ppk-studio';
      if (target === '/' || target === '') {
        target = '/ppk-studio';
      }
      localStorage.setItem('postLoginRedirect', target);
    } catch {}
    this.auth.login();
    return false;
  }
}




